import React from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Toolbox } from 'Components/toolbox/Toolbox';
import { PageWidth } from 'Components';

import 'Styles/components/main.less';

class MainContainer extends React.Component {
  static propTypes = {
    toolbox: PropTypes.object,
    shouldNotUsePageWidth: PropTypes.bool,
    width: PropTypes.object,
    className: PropTypes.string,
    setSectionRef: PropTypes.func,
  };

  static defaultProps = {
    shouldNotUsePageWidth: false,
    setSectionRef: () => {},
  };

  render() {
    const {
      toolbox,
      shouldNotUsePageWidth,
      width,
      className,
      setSectionRef,
    } = this.props;

    return (
      <section
        className={classNames('student-list-grid-component padded', className)}
        ref={setSectionRef}
      >
        {!shouldNotUsePageWidth ? (
          <PageWidth width={width}>{this.props.children}</PageWidth>
        ) : (
          this.props.children
        )}
        <Toolbox {...toolbox} />
      </section>
    );
  }
}

export const Main = withRouter(MainContainer);



// WEBPACK FOOTER //
// ./src/containers/app/Main.js